import React, { useState, useEffect } from "react";
import { ModalBody, ModalFooter } from "@vds/modals";
import { Loader } from "@vds/loaders";
import { Button, TextLink } from "@vds/buttons";
import styled from "styled-components";
import { Icon } from "@vds/icons";
import DownloadIcon from "../../assets/icons/download-small.png";
import DownArrowIcon from "../../assets/icons/down-arrow.svg";
import UpArrowIcon from "../../assets/icons/up-arrow.svg";
import AscendingSortIcon from "../../assets/icons/sort-ascending.png";
import DescendingSortIcon from "../../assets/icons/sort-descending.png";
import GreenCheckIcon from "../../assets/icons/Green_check.svg";
import WarningIcon from "../../assets/icons/Warning.svg";
import NoSort from "../../assets/icons/no-sort.png";
import { connect } from "react-redux";
import * as Actions from "../../store/actions/billing/invoiceHistoryActions";
import Pagination from "react-js-pagination";
import "./invoice.css";
import * as StyledTableCSS from "../../constants/common/StyledTableConstants";
import * as StyledPaginationCSS from "../../constants/common/StyledPaginationConstants";
import * as dateFormat from "../../util/dateUtils";
import { addCurrencySymbol } from "../../util/negativeAmountHandler";
import { setAlertState } from "../../util/util";
import { dateToday, dateTwoYearsAgo } from "../../util/billingUtils";
import { useTranslation } from "react-i18next";
import DateFilter from "../cases/DateFilter";
import { Wrapper, ModalBox, CustomTooltip, StyledImage, SortIconStyle, SortIconStyle1, CPButton } from "../../constants/common/StyledGlobalConstants";
import { getDateFormat, dateConversion, handleDateTimeZone } from "../../util/dateUtils";
import helpIcon from "../../assets/icons/Help.svg";
import InfoIcon from "../../assets/icons/InformationBW.png";
import CPIcon from "../../pages/Login/CPIcon";
import { Grid } from "@vds/grids";
import { useInvoicePreviewOrDownload } from "../../hooks/useInvoicePreviewOrDownload";
import { DEVICE_BREAKPOINTS } from "../../constants/appConstants";
import PropTypes from "prop-types";
import moment from "moment";
import { INVOICE_HISTORY_CONSTANTS } from "../../constants/StringConstants";
const { TABLET, DESKTOP, LARGE_DESKTOP } = DEVICE_BREAKPOINTS;

const MarginWrapper = styled.div`
  margin-top: 0.2em;
  margin-bottom: 0.2em;
  @media (max-width: 1023px) {
    font-size: 12px !important;
  }
`;

const MediumText = styled.p`
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1rem;
  font-family: neue-haas-grotesk-text, Helvetica, Ariel;
  margin: 0rem !important;
  @media (max-width: 1023px) {
    font-size: 0.625rem;
  }
  @media (min-width: 1024px) {
    font-family: neue-haas-grotesk-text;
  }
`;

const MediumTextTableHeader = styled.th`
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1rem;
  font-family: neue-haas-grotesk-text, Helvetica, Ariel;
  @media (max-width: 767px) {
    font-size: 0.75rem;
  }
  @media (min-width: 768px) {
    font-size: 0.875rem;
    font-family: neue-haas-grotesk-text;
  }
`;

const DateWidth = styled(Wrapper)`
  // @media (max-width: 480px) {
  //   width: 100%;
  //   margin-bottom: 1rem;
  // }
  // @media (min-width: 481px) and (max-width: 679px) {
  //   width: 49%;
  // }
`;

const CustomTextLink = styled(TextLink)`
  font-size: 12px;
  font-family: neue-haas-grotesk-text;
  color: #000000;
  cursor: pointer;
  @media (min-width: 1024px) {
    font-size: 14px;
    font-family: neue-haas-grotesk-text;
    color: #0077b4;
    border-bottom: 1px solid #0077b4;
    &:hover {
      color: #0077b4;
      border-bottom: 2px solid #0077b4;
    }
    &:active {
      color: #0077b4;
      border-bottom: 1px solid #0077b4;
    }
    &:focus {
      border-radius: 2px;
      font-size: 14px;
      outline: 2px solid #0077b4 !important;
    }
    ::after {
      border: none !important;
    }
  }
  @media (max-width: 1023px) {
    font-size: 14px;
    font-family: neue-haas-grotesk-text;
    color: #0077b4;
    border-bottom: 1px solid #0077b4;
    &:hover {
      color: #0077b4;
      border-bottom: 2px solid #0077b4;
    }
    &:active {
      color: #0077b4;
      border-bottom: 1px solid #0077b4;
    }
    &:focus {
      border-radius: 2px;
      font-size: 14px;
      outline: 2px solid #0077b4 !important;
    }
    ::after {
      border: none !important;
    }
  }
`;

const DownlodIconStyle = styled.img`
  width: 1.125rem;
  margin-right: 1.25rem;
  cursor: pointer;
  @media (min-width: 1024px) {
    width: 1rem;
    height: 1rem;
  }
`;

const TableRowIconStyle = styled.img`
  position: relative;
  // top: 1px;
  width: 10px;
  margin: 0 5px 0 0;
  @media (max-width: 1023px) {
    top: 1px;
  }
`;

const CustomWrapper = styled(StyledTableCSS.CustomWrapper)`
  display: flex;
  gap: 16px;
  @media (max-width: 1023px) {
    margin-top: 1.5rem;
  }
  @media (min-width: 1024px) {
    margin-top: 1.5rem;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: nowrap;
    & button {
      margin-top: auto;
    }
  }
  @media (min-width: 361px) {
    justify-content: flex-end;
  }
`;

function InvoiceHistory(props) {
  const [accordianArray, setAccordianArray] = useState([]);
  const [pageRangeDisplayed] = useState(5);
  const tableSearchRef = React.createRef();
  const { invoiceNumber, billingHistoryViewInvoiceError, downloadInvoiceError, handleInvoiceAction } = useInvoicePreviewOrDownload({
    setLoader: props.setLoader,
    accountNumber: props.accountNumber,
  });
  const { t } = useTranslation("billingTranslation");

  useEffect(() => {
    handleDateReset();
  }, [props.contractAccount]);

  useEffect(() => {
    if (billingHistoryViewInvoiceError) {
      window.scrollTo(0, 0);
      let timer = null;
      props.setViewInvoiceError({ isError: true, errorText: `${t("Invoice No", { number: invoiceNumber })}`, invoiceNumber: invoiceNumber });
      timer = setTimeout(function () {
        props.setViewInvoiceError({ isError: false, errorText: "", invoiceNumber: "" });
      }, 5000);
      return () => {
        clearTimeout(timer);
      };
    }
    if (downloadInvoiceError) {
      window.scrollTo(0, 0);
      let timer = null;
      props.setDownloadInvoiceError({
        isError: true,
        errorText: `${t("Invoice No", { number: invoiceNumber })}`,
        invoiceNumber: invoiceNumber,
      });
      timer = setTimeout(function () {
        props.setDownloadInvoiceError({ isError: false, errorText: "", invoiceNumber: "" });
      }, 5000);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [downloadInvoiceError, billingHistoryViewInvoiceError]);

  useEffect(() => {
    handleLoadTableData(props.recordsPerPage, props.actionName, props.invoiceList);
  }, [props.recordsPerPage, props.actionName, JSON.stringify(props.invoiceList), JSON.stringify(props.filteredData), props.activePage]);

  const handleLoadTableData = (perPage, actionName, data) => {
    const lastRecordIndex = props.activePage * props.recordsPerPage;
    const firstRecordIndex = lastRecordIndex - props.recordsPerPage;
    let slicedData = [];
    let inputData;
    if (actionName === "onLoad") {
      let fromDate = dateFormat.dateRangeFormat(props.dateFrom);
      let toDate = dateFormat.dateRangeFormat(props.dateTo);
      let from = new Date(fromDate);
      from.setHours(0, 0, 0);
      let to = new Date(toDate);
      to.setHours(23, 59, 59);
      let dataFilteredByDate = props.invoiceList.filter((history) => {
        let formattedDate = moment(history.invoiceDate, history.dateFormat.toUpperCase(), true).toDate();
        return formattedDate >= from && formattedDate <= to;
      });
      inputData = [...dataFilteredByDate];
      props.setFilteredData(dataFilteredByDate);
    } else {
      inputData = [...props.filteredData];
    }
    slicedData = inputData.slice(firstRecordIndex, lastRecordIndex);
    let pageCountValue = Math.ceil(inputData.length / props.recordsPerPage) === 0 ? "" : Math.ceil(inputData.length / props.recordsPerPage);
    props.setPageCount(pageCountValue);
    props.setTotalNumberOfRecords(inputData.length);
    props.setTableData(slicedData);
  };

  const handlePageChange = (pageNumber) => {
    let number = Number.parseInt(pageNumber);
    props.setActivePage(number);
    props.setPageCount(props.pageCount);
    props.setActionName("others");
  };
  const handleAccordianChange = (accordianId) => {
    let AccordianArray = [...accordianArray];
    if (AccordianArray?.includes(accordianId)) {
      AccordianArray = AccordianArray.filter((currentInvoice) => currentInvoice != accordianId);
    } else {
      AccordianArray.push(accordianId);
    }
    setAccordianArray(AccordianArray);
  };

  const handleSingleDownload = (invoiceNo, contractAccount) => {
    let action = {
      type: "DownloadInvoice",
      sourceComponent: "InvoiceHistory",
    };
    handleInvoiceAction(invoiceNo, action, contractAccount);
  };

  const updateSortStatus = (statusName, result) => {
    const sortStatusMap = {
      sortStatusInvoiceNo: props.setSortStatusInvoiceNo,
      sortStatusInvoiceDate: props.setSortStatusInvoiceDate,
      sortStatusContract: props.setSortStatusContract,
      sortStatusLocation: props.setSortStatusLocation,
      sortStatusAmount: props.setSortStatusAmount,
      sortStatusDueAmount: props.setSortStatusDueAmount,
      sortStatusPayStatus: props.setSortStatusPayStatus,
      sortStatusDueDate: props.setSortStatusDueDate,
    };

    if (sortStatusMap[statusName]) {
      sortStatusMap[statusName](result);
    }
  };

  const resetOtherSortStatuses = (statusName) => {
    const sortStatusKeys = [
      "sortStatusInvoiceNo",
      "sortStatusInvoiceDate",
      "sortStatusContract",
      "sortStatusLocation",
      "sortStatusAmount",
      "sortStatusDueAmount",
      "sortStatusPayStatus",
      "sortStatusDueDate",
    ];

    sortStatusKeys.forEach((key) => {
      if (key !== statusName) {
        updateSortStatus(key, "noSort");
      }
    });
  };

  const tableSort = (value, status, statusName) => {
    const result = status === "ascending" ? "descending" : "ascending";
    updateSortStatus(statusName, result);

    const isDescending = status !== "ascending";
    sortFields(value, isDescending);

    resetOtherSortStatuses(statusName);
  };

  const sortFields = (filterField, status) => {
    let filterPaymentArr = props.filteredData;
    let filteredDataLocal;
    if (filterField === "invoiceDate" || filterField === "dueDate") {
      if (status === true) {
        filterPaymentArr.sort(function (a, b) {
          let c = new Date(a[filterField]);
          let d = new Date(b[filterField]);
          return c - d;
        });
        filteredDataLocal = filterPaymentArr;
      } else {
        filterPaymentArr.sort(function (b, a) {
          let c = new Date(a[filterField]);
          let d = new Date(b[filterField]);
          return c - d;
        });
        filteredDataLocal = filterPaymentArr;
      }
    } else if (filterField === "invoiceNumber" || filterField === "totalAmountDue" || filterField === "totalAmount") {
      if (status === true) {
        filterPaymentArr.sort(function (b, a) {
          let c = a[filterField].trim().length === 0 ? 0 : Number(a[filterField]);
          let d = b[filterField].trim().length === 0 ? 0 : Number(b[filterField]);
          return d - c;
        });
        filteredDataLocal = filterPaymentArr;
      } else {
        filterPaymentArr.sort(function (a, b) {
          let c = a[filterField].trim().length === 0 ? 0 : Number(a[filterField]);
          let d = b[filterField].trim().length === 0 ? 0 : Number(b[filterField]);
          return d - c;
        });
        filteredDataLocal = filterPaymentArr;
      }
    } else {
      status === true
        ? filterPaymentArr.sort((a, b) => {
          const aField = a[filterField].toLowerCase();
          const bField = b[filterField].toLowerCase();
          let comparison = 0;
          if (aField < bField) {
            comparison = -1;
          } else if (aField > bField) {
            comparison = 1;
          }
          return comparison;
        })
        : filterPaymentArr.sort((b, a) => {
          const aField = a[filterField].toLowerCase();
          const bField = b[filterField].toLowerCase();
          let comparison = 0;
          if (aField < bField) {
            comparison = -1;
          } else if (aField > bField) {
            comparison = 1;
          }
          return comparison;
        });
      filteredDataLocal = filterPaymentArr;
    }

    props.setFilteredData(filteredDataLocal);
    props.setActionName("onchange");
  };

  const handleDateFrom = (value) => {
    props.setDateFrom(dateConversion(new Date(value)));
    props.setSearchOrRefresh(true);
  };

  const handleDateTo = (value) => {
    props.setDateTo(dateConversion(new Date(value)));
    props.setSearchOrRefresh(true);
    let fromDate = new Date(props.dateFrom);
    let toDate = new Date(value);
    toDate.setHours(23, 59, 59);
    if (toDate < fromDate) {
      props.setDateTo(dateToday());
    }
  };

  const handleDateRange = () => {
    handleCommon();
    handleCommon("apply");
    tableSearchRef.current.focus();
  };

  const handleDateReset = () => {
    let from = dateTwoYearsAgo();
    let to = dateToday();
    props.setDateFrom(from);
    props.setDateTo(to);
    handleCommon("reset", props.inputValue, from, to);
  };

  const handleCommon = (searchState = "apply", value = props.inputValue, dateFromValue = props.dateFrom, dateToValue = props.dateTo) => {
    props.setSortStatusInvoiceNo("noSort");
    props.setSortStatusInvoiceDate("descending");
    props.setSortStatusContract("noSort");
    props.setSortStatusLocation("noSort");
    props.setSortStatusAmount("noSort");
    props.setSortStatusDueAmount("noSort");
    props.setSortStatusPayStatus("noSort");
    props.setSortStatusDueDate("noSort");
    let filteredData = props.invoiceList;
    if (dateFromValue != "" && dateToValue) {
      if (searchState === "apply") props.setSearchOrRefresh(false);
      else props.setSearchOrRefresh(true);
      let fromDate = dateFormat.dateRangeFormat(dateFromValue);
      let toDate = dateFormat.dateRangeFormat(dateToValue);
      let from = new Date(fromDate);
      from.setHours(0, 0, 0);
      let to = new Date(toDate);
      to.setHours(23, 59, 59);
      filteredData = props.invoiceList.filter((history) => {
        let formattedDate = moment(history.invoiceDate, history.dateFormat.toUpperCase(), true).toDate();
        return formattedDate >= from && formattedDate <= to;
      });
    }
    let searchBasedOn = props.selectedFilterBy;
    let searchResult;
    props.setActivePage(1);
    if (!props.inputValue || props.inputValue.trim().length === 0) {
      searchResult = [...filteredData];
    } else {
      searchResult = filteredData.filter((payment) => {
        if (searchBasedOn === "dueDate") {
          let dateData = dateFormat.handleDateSearch(payment[searchBasedOn]);
          return payment[searchBasedOn] && dateData.includes(props.inputValue.toLowerCase().trim());
        } else {
          return payment[searchBasedOn]?.toString().toLowerCase().includes(props.inputValue.toLowerCase().trim());
        }
      });
    }
    props.setFilteredData(searchResult);
    props.setActionName("others");
  };

  function showBill(invoiceNo, contractAccount) {
    let action = {
      type: "ViewInvoice",
      sourceComponent: "InvoiceHistory",
    };
    handleInvoiceAction(invoiceNo, action, contractAccount);
  }

  const handleErrorModal = (value) => {
    setAlertState(false);
    props.setAlertModal(value);
  };
  const getInvoiceNumberId = (userLanguage) => {
    const languageIdMap = {
      "en-US": "mobile-invoice-number-data-en-US",
      "nl-NL": "mobile-invoice-number-data-nl-NL",
      "de-DE": "mobile-invoice-number-data-de-DE",
      "fr-FR": "mobile-invoice-number-data-fr-FR",
    };

    return languageIdMap[userLanguage] || "";
  };
  const getInvoiceDateId = (userLanguage) => {
    const languageIdMap = {
      "en-US": "mobile-invoice-date-data-en-US",
      "nl-NL": "mobile-invoice-date-data-nl-NL",
      "de-DE": "mobile-invoice-date-data-de-DE",
      "fr-FR": "mobile-invoice-date-data-fr-FR",
    };

    return languageIdMap[userLanguage] || "";
  };
  const getAccordionId = (userLanguage) => {
    const languageIdMap = {
      "en-US": "mobile-accordian-en-US",
      "nl-NL": "mobile-accordian-nl-NL",
      "de-DE": "mobile-accordian-de-DE",
      "fr-FR": "mobile-accordian-fr-FR",
    };

    return languageIdMap[userLanguage] || "";
  };

  const getLanguageId = (userLanguage, type) => {
    const languageIdMap = {
      "fr-FR": `${type}-fr`,
      "nl-NL": `${type}-nl`,
      "de-DE": `${type}-de`,
      "en-US": `${type}-en`,
    };
    return languageIdMap[userLanguage] || `${type}-default`;
  };
  const getInvoiceHeaderId = (userLanguage) => {
    const languageIdMap = {
      "en-US": "mobile-invoice-number-header-en-US",
      "nl-NL": "mobile-invoice-number-header-nl-NL",
      "de-DE": "mobile-invoice-number-header-de-DE",
      "fr-FR": "mobile-invoice-number-header-fr-FR",
    };

    return languageIdMap[userLanguage] || "";
  };
  const getInvoiceDateHeaderId = (userLanguage) => {
    const languageIdMap = {
      "en-US": "mobile-invoice-date-header-en-US",
      "nl-NL": "mobile-invoice-date-header-nl-NL",
      "de-DE": "mobile-invoice-date-header-de-DE",
      "fr-FR": "mobile-invoice-date-header-fr-FR",
    };

    return languageIdMap[userLanguage] || "";
  };
  const getTooltipClassName = (userLanguage) => {
    const languageClassMap = {
      "en-US": "mobile-tooltip-en-US",
      "nl-NL": "mobile-tooltip-nl-NL",
      "de-DE": "mobile-tooltip-de-DE",
      "fr-FR": "mobile-tooltip-fr-FR",
    };

    return languageClassMap[userLanguage] || "";
  };

  const renderMobileViewInvoiceNumber = (invoice) => {
    if (props.viewInvoicesPermission !== "ReadOnly") {
      if (invoice.invoiceAvailable) {
        return (
          <CustomTextLink
            id="invoice-history-view-invoice"
            size="small"
            type="standAlone"
            onClick={() => showBill(invoice.invoiceNumber, props.contractAccount)}
            tabIndex="0"
            ariaLabel={invoice.invoiceNumber + " invoice number"}
          >
            {invoice.invoiceNumber}
          </CustomTextLink>
        );
      } else {
        return (
          <CustomTextLink
            id="invoice-history-view-invoice"
            size="small"
            type="standAlone"
            tabIndex="-1"
            ariaLabel={invoice.invoiceNumber + " invoice number"}
            disabled={true}
            style={{
              pointerEvents: "none", color: "#bdbdbd", cursor: "not-allowed",
              textDecoration: "none",
              borderBottom: "none"
            }}>
            {invoice.invoiceNumber}
          </CustomTextLink>
        );
      }
    } else {
      return <div>{invoice.invoiceNumber}</div>
    }
  }

  const renderInvoiceRow = (invoice, index) => {
    const isDesktop = props.windowSize.width >= DESKTOP;
    const isReadOnly = props.viewInvoicesPermission === "ReadOnly";

    return (
      <StyledTableCSS.TableBodyContainer key={invoice.invoiceId}>
        <td style={{ width: props.windowSize.width < DESKTOP ? "18.5%" : "15.5%" }} id={getLanguageId(props.userLanguage, "invoice-date-data")}>
          <MediumText>{invoice.invoiceDate}</MediumText>
        </td>
        <td
          style={{
            width: props.windowSize.width < DESKTOP ? "21.5%" : "16%",
          }}
          id={getLanguageId(props.userLanguage, "invoice-number-data")}
        >
          {(() => {
            let invoiceNumberContent;
            if (isReadOnly) {
              invoiceNumberContent = <MediumText>{invoice.invoiceNumber}</MediumText>;
            } else if (isDesktop) {
              invoiceNumberContent = (
                invoice.invoiceAvailable ?
                  <TextLink
                    id="invoice-history-view-invoice"
                    size="small"
                    type="standAlone"
                    onClick={() => showBill(invoice.invoiceNumber, props.contractAccount)}
                    tabIndex="0"
                    ariaLabel={`${invoice.invoiceNumber} invoice number`}
                  >
                    {invoice.invoiceNumber}
                  </TextLink>
                  :
                  <TextLink
                    id="invoice-history-view-invoice"
                    size="small"
                    type="standAlone"
                    tabIndex="-1"
                    ariaLabel={`${invoice.invoiceNumber} invoice number`}
                    disabled={true}
                    style={{
                      pointerEvents: "none", color: "#bdbdbd", cursor: "not-allowed",
                      textDecoration: "none",
                      borderBottom: "none"
                    }}>
                    {invoice.invoiceNumber}
                  </TextLink>


              );
            } else {
              invoiceNumberContent = <MediumText>{invoice.invoiceNumber}</MediumText>;
            }
            return invoiceNumberContent;
          })()}
        </td>
        <td
          style={{
            width: props.windowSize.width < DESKTOP ? "17%" : "14%",
            position: "relative",
          }}
          id={getLanguageId(props.userLanguage, "invoice-amount-data")}
        >
          <MediumText>{addCurrencySymbol(invoice.totalAmount, props.currencySymbol)}</MediumText>
        </td>
        <td style={{ width: props.windowSize.width < DESKTOP ? "16.5%" : "13%" }} id={getLanguageId(props.userLanguage, "invoice-amount-due-data")}>
          <MediumText>{addCurrencySymbol(invoice.totalAmountDue, props.currencySymbol)}</MediumText>
        </td>
        <td
          style={{
            width: props.windowSize.width < DESKTOP ? "17%" : "14.5%",
            position: "relative",
            wordWrap: "break-word",
          }}
          id={getLanguageId(props.userLanguage, "invoice-status-data")}
        >
          <MediumText>{t(`${invoice.status}`)}</MediumText>
        </td>
        {isDesktop && (
          <>
            <td
              style={{
                width: "12.5%",
                position: "relative",
              }}
              id={getLanguageId(props.userLanguage, "invoice-due-date-data")}
            >
              <MediumText>{invoice.formattedDueDate}</MediumText>
            </td>
            <td className="icon-wrapper" id={getLanguageId(props.userLanguage, "invoice-download-data")}>
              {!isReadOnly && (
                invoice.invoiceAvailable ? <CPIcon
                  id="download-invoice"
                  tabIndex="0"
                  ariaLabel="Download selected invoice"
                  clickHandler={() => handleSingleDownload(invoice.invoiceNumber, props.contractAccount)}
                /> : <><MediumText>{INVOICE_HISTORY_CONSTANTS.AVAILABLE_ON}</MediumText>
                  <MediumText>{invoice.invoiceAvailableDate}</MediumText></>
              )}
            </td>
          </>
        )}
      </StyledTableCSS.TableBodyContainer>
    );
  };
  const renderMobileInvoiceRow = () => {
    return (
      <Wrapper style={{ borderTop: "2.5px solid #000000" }} marginTop={props.windowSize.width < TABLET ? "40px" : "24px"} ref={tableSearchRef}>
        {props.tableData.length ? (
          props.tableData.map((invoice) => (
            <Grid colSizes={{ mobile: 2, tablet: 6 }} key={invoice.accordianId}>
              <StyledTableCSS.StyledRow>
                <StyledTableCSS.LeftAlignedCol> {t("Invoice date")}</StyledTableCSS.LeftAlignedCol>
                <StyledTableCSS.RightAlignedCol>{invoice.invoiceDate}</StyledTableCSS.RightAlignedCol>
              </StyledTableCSS.StyledRow>
              <StyledTableCSS.StyledRow>
                <StyledTableCSS.LeftAlignedCol> {t("Invoice number")}</StyledTableCSS.LeftAlignedCol>
                <StyledTableCSS.RightAlignedCol>
                  <>
                    {
                      renderMobileViewInvoiceNumber(invoice)
                    }
                  </>
                </StyledTableCSS.RightAlignedCol>
              </StyledTableCSS.StyledRow>
              <StyledTableCSS.StyledRow>
                <StyledTableCSS.LeftAlignedCol> {t("Invoice amount")}</StyledTableCSS.LeftAlignedCol>
                <StyledTableCSS.RightAlignedCol>{addCurrencySymbol(invoice.totalAmount, props.currencySymbol)}</StyledTableCSS.RightAlignedCol>
              </StyledTableCSS.StyledRow>
              <StyledTableCSS.StyledRow>
                <StyledTableCSS.LeftAlignedCol> {t("Invoice balance")}</StyledTableCSS.LeftAlignedCol>
                <StyledTableCSS.RightAlignedCol>{addCurrencySymbol(invoice.totalAmountDue, props.currencySymbol)}</StyledTableCSS.RightAlignedCol>
              </StyledTableCSS.StyledRow>
              <StyledTableCSS.StyledRow>
                <StyledTableCSS.LeftAlignedCol> {t("Invoice status")}</StyledTableCSS.LeftAlignedCol>
                <StyledTableCSS.RightAlignedCol>{t(`${invoice.status}`)}</StyledTableCSS.RightAlignedCol>
              </StyledTableCSS.StyledRow>
              <StyledTableCSS.StyledRow>
                <StyledTableCSS.LeftAlignedCol> {t("Due date")}</StyledTableCSS.LeftAlignedCol>
                <StyledTableCSS.RightAlignedCol>{invoice.formattedDueDate}</StyledTableCSS.RightAlignedCol>
              </StyledTableCSS.StyledRow>
              <>
                {props.viewInvoicesPermission !== "ReadOnly" && (
                  invoice.invoiceAvailable ?
                    <Wrapper margin="16px !important">
                      <CPIcon
                        id="download-invoice"
                        tabIndex="0"
                        ariaLabel="Download selected invoice"
                        clickHandler={() => handleSingleDownload(invoice.invoiceNumber, props.contractAccount)}
                      />
                    </Wrapper> :
                    <StyledTableCSS.StyledRow>
                      <StyledTableCSS.LeftAlignedCol> {INVOICE_HISTORY_CONSTANTS.AVAILABLE_ON}</StyledTableCSS.LeftAlignedCol>
                      <StyledTableCSS.RightAlignedCol>{invoice.invoiceAvailableDate}</StyledTableCSS.RightAlignedCol>
                    </StyledTableCSS.StyledRow>
                )}
              </>


              <Wrapper borderTop={"1px solid #D8DADA"}></Wrapper>
            </Grid>
          ))
        ) : (
          <Wrapper>
            <Wrapper padding="8px 16px" style={{ borderBottom: "1px solid #d8dada", fontWeight: 700 }} aria-label="No Records to display">
              {t("No Records to display")}
            </Wrapper>
          </Wrapper>
        )}
      </Wrapper>
    );
  };
  const getPaddingTop = (windowSize) => {
    return windowSize.width < DESKTOP ? "2rem" : undefined;
  };
  const getWidth = (windowSize) => {
    return windowSize.width < DESKTOP ? "100%" : "6.25rem";
  };
  const renderAccordionRow = (invoice) => (
    <StyledTableCSS.TableBodyContainer key={invoice.invoiceId} style={{ flexDirection: "column" }}>
      <StyledTableCSS.AccordianDiv>
        <StyledTableCSS.AccordianSpanHeader>
          {t("Due date")} <span style={{ fontSize: "0.625rem", fontWeight: "bold" }}>{` [${t(getDateFormat(props.regionId))}]`}</span>
        </StyledTableCSS.AccordianSpanHeader>
        <StyledTableCSS.AccordianSpanBody>{invoice.formattedDueDate}</StyledTableCSS.AccordianSpanBody>
      </StyledTableCSS.AccordianDiv>
      <StyledTableCSS.AccordianDiv>
        <Wrapper>
          {props.viewInvoicesPermission !== "ReadOnly" && (
            <DownlodIconStyle
              id="download-invoice"
              alt="download-icon"
              tabIndex="0"
              aria-label="Download selected invoice"
              src={DownloadIcon}
              onClick={() => handleSingleDownload(invoice.invoiceNumber, props.contractAccount)}
            />
          )}
        </Wrapper>
        <Wrapper>
          <CustomTextLink onClick={() => handleSingleDownload(invoice.invoiceNumber, props.contractAccount)}>{t("Download Invoice")}</CustomTextLink>
        </Wrapper>
      </StyledTableCSS.AccordianDiv>
    </StyledTableCSS.TableBodyContainer>
  );
  const getButtonProps = (isApplyButton, windowSize) => {
    let marginTopValue;
    if (windowSize.width < TABLET) {
      marginTopValue = "0rem";
    } else if (windowSize.width >= DESKTOP) {
      marginTopValue = "30px";
    } else {
      marginTopValue = "auto";
    }
    let buttonHeightValue;
    if (isApplyButton) {
      buttonHeightValue = windowSize.width < DESKTOP ? "2.5rem" : "2rem";
    } else if (windowSize.width < TABLET) {
      buttonHeightValue = "2.5rem";
    } else if (windowSize.width >= DESKTOP) {
      buttonHeightValue = "2rem";
    }
    return {
      id: isApplyButton ? "invoice-date-apply-button" : "invoice-date-reset-button",
      boxButton: true,
      marginTop: { marginTopValue },
      buttonHeight: { buttonHeightValue },
      width: windowSize.width < TABLET && "100%",
      secondary: true,
      onClick: isApplyButton ? handleDateRange : handleDateReset,
      fontSize: "14px",
      fontPaddingLeft: "0rem",
      fontPaddingRight: "0rem",
      size: isApplyButton ? "large" : undefined,
    };
  };

  const getDynamicId = (userLanguage, idVariable) => {
    const mobileInvoiceAmountHeaderId = {
      "en-US": "mobile-invoice-amount-header-en-US",
      "nl-NL": "mobile-invoice-amount-header-nl-NL",
      "de-DE": "mobile-invoice-amount-header-de-DE",
      "fr-FR": "mobile-invoice-amount-header-fr-FR",
    };

    const invoiceDateHeaderId = {
      "en-US": "invoice-date-header-en",
      "nl-NL": "invoice-date-header-nl",
      "de-DE": "invoice-date-header-de",
      "fr-FR": "invoice-date-header-fr",
    };

    const invoiceNumberHeaderId = {
      "en-US": "invoice-number-header-en",
      "nl-NL": "invoice-number-header-nl",
      "de-DE": "invoice-number-header-de",
      "fr-FR": "invoice-number-header-fr",
    };

    const invoiceAmountHeaderId = {
      "en-US": "invoice-amount-header-en",
      "nl-NL": "invoice-amount-header-nl",
      "de-DE": "invoice-amount-header-de",
      "fr-FR": "invoice-amount-header-fr",
    };

    const invoiceBalanceHeaderId = {
      "en-US": "invoice-balance-header-en",
      "nl-NL": "invoice-balance-header-nl",
      "de-DE": "invoice-balance-header-de",
      "fr-FR": "invoice-balance-header-fr",
    };

    const invoiceStatusHeaderId = {
      "en-US": "invoice-status-header-en",
      "nl-NL": "invoice-status-header-nl",
      "de-DE": "invoice-status-header-de",
      "fr-FR": "invoice-status-header-fr",
    };

    const dueDateHeaderId = {
      "en-US": "due-date-header-en",
      "nl-NL": "due-date-header-nl",
      "de-DE": "due-date-header-de",
      "fr-FR": "due-date-header-fr",
    };

    const downloadHeaderId = {
      "en-US": "download-header-en",
      "nl-NL": "download-header-nl",
      "de-DE": "download-header-de",
      "fr-FR": "download-header-fr",
    };

    const idVariableMap = {
      mobileInvoiceAmountHeaderId: mobileInvoiceAmountHeaderId,
      invoiceDateHeaderId: invoiceDateHeaderId,
      invoiceNumberHeaderId: invoiceNumberHeaderId,
      invoiceAmountHeaderId: invoiceAmountHeaderId,
      invoiceBalanceHeaderId: invoiceBalanceHeaderId,
      invoiceStatusHeaderId: invoiceStatusHeaderId,
      dueDateHeaderId: dueDateHeaderId,
      downloadHeaderId: downloadHeaderId,
    };

    return idVariableMap[idVariable][userLanguage] || "";
  };

  const renderSortingIcons = (sortType) => {
    if (sortType === "ascending") {
      return <SortIconStyle1 alt="ascending-icon" src={AscendingSortIcon} aria-hidden="true" tabIndex="-1" />;
    } else if (sortType === "descending") {
      return <SortIconStyle1 alt="descending-icon" src={DescendingSortIcon} aria-hidden="true" tabIndex="-1" />;
    } else {
      return <SortIconStyle alt="search-icon" src={NoSort} aria-hidden="true" tabIndex="-1" />;
    }
  };

  const getFilterButton = () => {
    const filterButtonText = {
      true: "APPLY",
      false: "RESET",
    };

    return filterButtonText[props.searchOrRefresh] || "";
  };

  const getSortStatusTxt = (sortStatusTxt) => {
    const sortStatusMap = {
      noSort: "other",
    };
    return sortStatusMap[sortStatusTxt] || sortStatusTxt;
  };
  // `${props.windowSize.width <= 350 ? "319px" : ""}`

  const getDynamicValue = (val) => {
    const dynamicValues = {
      "319px": props.windowSize.width <= 350 ? "319px" : "",
      scroll: props.windowSize.width <= 350 ? "scroll" : "",
      "451px": props.windowSize.width <= 350 ? "451px" : "100%",
    };
    return dynamicValues[val] || "";
  };

  const renderDesktopViewInvoiceNumber = (invoice) => {
    if (props.viewInvoicesPermission !== "ReadOnly") {
      if (invoice.invoiceAvailable) {
        return (
          <TextLink
            id="invoice-history-view-invoice"
            size="small"
            type="standAlone"
            onClick={() => showBill(invoice.invoiceNumber, props.contractAccount)}
            tabIndex="0"
            ariaLabel={invoice.invoiceNumber + " invoice number"}
          >
            {invoice.invoiceNumber}
          </TextLink>
        );
      }
      else {
        return (
          <TextLink
            id="invoice-history-view-invoice"
            size="small"
            type="standAlone"
            tabIndex="-1"
            ariaLabel={invoice.invoiceNumber + " invoice number"}
            disabled={true}
            style={{
              pointerEvents: "none", color: "#bdbdbd", cursor: "not-allowed",
              textDecoration: "none",
              borderBottom: "none"
            }}>
            {invoice.invoiceNumber}
          </TextLink>
        );
      }
    } else {
      return <>{invoice.invoiceNumber}</>
    }
  }

  return (
    <>
      <Loader active={props.loader} fullscreen={true} />
      <div>
        <ModalBox
          ariaLabel=""
          opened={props.alertModal}
          closeButton={
            <Wrapper onClick={handleErrorModal} marginRight="1rem" marginLeft="auto">
              <Icon name="close" size="medium" color="#000000" style={{ cursor: "pointer", float: "right" }} />
            </Wrapper>
          }
          disableOutsideClick={true}
          paddingTop="2rem"
          modalBodyPaddingTop="0rem"
          modalFooterPaddingTop="2.4rem"
          modalFooterWidth="65%"
          lineHeight="1.35rem"
          height="18rem"
          maxHeight="50vh"
          width="35rem"
          maxWidth="35rem"
          mobHeight="38vh"
          mobMaxHeight="70vh"
          mobWidth="85vw"
          mobMaxWidth="90vw"
          mobPaddingTop="2rem"
          mobBodyPaddingTop="0rem"
        >
          <ModalBody>
            <Wrapper style={{ paddingTop: getPaddingTop(props.windowSize) }}>
              {t("We are unable to process your request for invoice history. Please try again.")}
            </Wrapper>
          </ModalBody>
          <ModalFooter>
            <Wrapper marginLeft="auto" width={props.windowSize.width < DESKTOP && "100%"}>
              <Button
                secondary
                size="large"
                onClick={() => {
                  setAlertState(false);
                  props.setAlertModal(false);
                }}
                width={getWidth(props.windowSize)}
              >
                {t("OK")}
              </Button>
            </Wrapper>
          </ModalFooter>
        </ModalBox>
      </div>

      <StyledTableCSS.CustomModal ariaLabel="" opened={props.showModal}>
        <ModalBody className="modalBodyPaddingTop">{t("Please select multiple rows to download the invoices")}</ModalBody>
        <StyledTableCSS.ButtonWrapper>
          <Button secondary size="large" onClick={() => props.setShowModal(false)}>
            {t("OK")}
          </Button>
        </StyledTableCSS.ButtonWrapper>
      </StyledTableCSS.CustomModal>
      <>
        <CustomWrapper>
          <Wrapper
            aria-label="Date Range Filter"
            display="inline-flex"
            justifyContent="flex-end"
            width={props.windowSize.width < TABLET && "100%"}
            style={{ gap: "16px", flexWrap: "nowrap" }}
            flexDirection={props.windowSize.width < TABLET && "column"}
          >
            <DateWidth>
              <DateFilter
                labelText={t("From")}
                date={handleDateTimeZone(props.dateFrom)}
                ariaLabelledby={"dateFrom"}
                handleDateFilter={(value) => (value ? handleDateFrom(value) : props.setDateFrom(""))}
                placeHolder={t(getDateFormat(props.regionId))}
                inputWidth="inherit"
                marginRight={"0"}
              />
              <span style={{ fontWeight: "400", fontSize: "0.75rem", color: "#747474", fontFamily: "neue-haas-grotesk-text" }}>
                {" "}
                {`${t(getDateFormat(props.regionId))}`}
              </span>
            </DateWidth>
            <DateWidth>
              <DateFilter
                labelText={t("To")}
                date={handleDateTimeZone(props.dateTo)}
                ariaLabelledby={"dateTo"}
                handleDateFilter={(value) => (value ? handleDateTo(value) : props.setDateTo(""))}
                placeHolder={t(getDateFormat(props.regionId))}
                marginRight={"0"}
                inputWidth="inherit"
              />
              <span style={{ fontWeight: "400", fontSize: "0.75rem", color: "#747474", fontFamily: "neue-haas-grotesk-text" }}>
                {" "}
                {`${t(getDateFormat(props.regionId))}`}
              </span>
            </DateWidth>
          </Wrapper>
          <StyledTableCSS.FilterWrapper>
            {<CPButton {...getButtonProps(props.searchOrRefresh, props.windowSize)}>{t(getFilterButton())}</CPButton>}
          </StyledTableCSS.FilterWrapper>
        </CustomWrapper>
        {props.windowSize.width >= DESKTOP && props.windowSize.width < LARGE_DESKTOP ? (
          <div style={{ width: getDynamicValue("width"), overflowX: getDynamicValue("scroll") }}>
            <StyledTableCSS.TableWrapper aria-label="Invoice history" ref={tableSearchRef} width={getDynamicValue("451px")}>
              <thead>
                <StyledTableCSS.TableHeaderContainer aria-label="Table Header">
                  <MediumTextTableHeader
                    className="tableHeaderStyle"
                    id={getInvoiceHeaderId(props.userLanguage)}
                    aria-sort={getSortStatusTxt(props.sortStatusInvoiceNo)}
                    scope="col"
                    style={{ width: "31%", display: "flex", flexDirection: "column" }}
                  >
                    <button
                      style={{ paddingBottom: "5px" }}
                      className="sortableCol"
                      tabIndex="0"
                      id="invoiceNum"
                      onClick={() => tableSort("invoiceNumber", props.sortStatusInvoiceNo, "sortStatusInvoiceNo")}
                    >
                      {t("Invoice number")}
                      {renderSortingIcons(props.sortStatusInvoiceNo)}
                    </button>
                    <span className="toolTipStyle">
                      {t("View details")}{" "}
                      <CustomTooltip
                        className={getTooltipClassName(props.userLanguage)}
                        renderAnchorElement={() => (
                          <StyledImage
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                            width="0.75rem"
                            src={helpIcon}
                            alt="help"
                          />
                        )}
                      >
                        {t("Click on the invoice number to view the invoice. Click on the download icon to download a copy.")}
                      </CustomTooltip>
                    </span>
                  </MediumTextTableHeader>
                  <MediumTextTableHeader
                    className="tableHeaderStyle"
                    id={getInvoiceDateHeaderId(props.userLanguage)}
                    scope="col"
                    style={{ width: "31%", display: "flex", flexDirection: "column" }}
                    aria-sort={getSortStatusTxt(props.sortStatusInvoiceDate)}
                  >
                    <button
                      id="sort-invoice-date"
                      className="sortableCol"
                      style={{ paddingBottom: "5px" }}
                      tabIndex="0"
                      onClick={() => tableSort("invoiceDate", props.sortStatusInvoiceDate, "sortStatusInvoiceDate")}
                    >
                      {t("Invoice date")}
                      {renderSortingIcons(props.sortStatusInvoiceDate)}
                    </button>
                    <span style={{ fontSize: "0.75rem", fontWeight: "bold" }}>{` [${t(getDateFormat(props.regionId))}]`}</span>
                  </MediumTextTableHeader>
                  <MediumTextTableHeader
                    style={{ width: "31%" }}
                    id={getDynamicId(props.userLanguage, "mobileInvoiceAmountHeaderId")}
                    scope="col"
                    className="tableHeaderStyle tableHeaderRes"
                  >
                    {t("Invoice amount")}
                  </MediumTextTableHeader>
                </StyledTableCSS.TableHeaderContainer>
              </thead>

              <tbody>
                {props.tableData.length !== 0 ? (
                  props.tableData.map((invoice, index) => (
                    <>
                      <StyledTableCSS.TableBodyContainer key={invoice.invoiceId}>
                        <td
                          style={{
                            width: "31%",
                          }}
                          id={getInvoiceNumberId(props.userLanguage)}
                        >
                          <MarginWrapper>
                            <TableRowIconStyle
                              alt="green-check-icon"
                              src={invoice?.status === "Paid" ? GreenCheckIcon : WarningIcon}
                              aria-hidden="true"
                              tabIndex="-1"
                            />
                            {renderDesktopViewInvoiceNumber(invoice)}

                          </MarginWrapper>
                        </td>
                        <td style={{ width: "31%" }} id={getInvoiceDateId(props.userLanguage)}>
                          <MarginWrapper>{invoice.invoiceDate}</MarginWrapper>
                        </td>
                        <td
                          style={{
                            width: "31%",
                          }}
                          id={getInvoiceDateId(props.userLanguage)}
                        >
                          <MarginWrapper>{addCurrencySymbol(invoice.totalAmount, props.currencySymbol)}</MarginWrapper>
                        </td>
                        <td
                          style={{
                            width: "7%",
                          }}
                          id={getAccordionId(props.userLanguage)}
                        >
                          <div style={{ float: "right" }}>
                            <DownlodIconStyle
                              tabIndex="0"
                              src={accordianArray.includes(invoice.accordianId) ? UpArrowIcon : DownArrowIcon}
                              onClick={() => handleAccordianChange(invoice.accordianId)}
                            />
                          </div>
                        </td>
                      </StyledTableCSS.TableBodyContainer>
                      {accordianArray.includes(invoice.accordianId) && (
                        <StyledTableCSS.TableBodyContainer key={invoice.invoiceId}>
                          <td style={{ width: "100%" }}>
                            <StyledTableCSS.AccordianDiv>
                              <StyledTableCSS.AccordianSpanHeader>{t("Invoice status")}</StyledTableCSS.AccordianSpanHeader>
                              <StyledTableCSS.AccordianSpanBody>
                                {t(`${invoice.status}`)}
                                <TableRowIconStyle
                                  style={{ margin: "0 0 0 5px", top: "0px" }}
                                  alt="green-check-icon"
                                  src={invoice?.status === "Paid" ? GreenCheckIcon : WarningIcon}
                                  aria-hidden="true"
                                  tabIndex="-1"
                                />
                              </StyledTableCSS.AccordianSpanBody>
                            </StyledTableCSS.AccordianDiv>
                            <StyledTableCSS.AccordianDiv>
                              <StyledTableCSS.AccordianSpanHeader>{t("Invoice balance")}</StyledTableCSS.AccordianSpanHeader>
                              <StyledTableCSS.AccordianSpanBody>
                                {addCurrencySymbol(invoice.totalAmountDue, props.currencySymbol)}
                              </StyledTableCSS.AccordianSpanBody>
                            </StyledTableCSS.AccordianDiv>
                            <StyledTableCSS.AccordianDiv>
                              <StyledTableCSS.AccordianSpanHeader>{t("Invoice amount")}</StyledTableCSS.AccordianSpanHeader>
                              <StyledTableCSS.AccordianSpanBody>
                                {addCurrencySymbol(invoice.totalAmount, props.currencySymbol)}
                              </StyledTableCSS.AccordianSpanBody>
                            </StyledTableCSS.AccordianDiv>
                            <StyledTableCSS.AccordianDiv>
                              <StyledTableCSS.AccordianSpanHeader>
                                {t("Invoice date")}
                                <div style={{ fontSize: "0.75rem", fontWeight: "bold" }}>{` [${t(getDateFormat(props.regionId))}]`}</div>
                              </StyledTableCSS.AccordianSpanHeader>
                              <StyledTableCSS.AccordianSpanBody>{invoice.invoiceDate}</StyledTableCSS.AccordianSpanBody>
                            </StyledTableCSS.AccordianDiv>
                            <StyledTableCSS.AccordianDiv>
                              <StyledTableCSS.AccordianSpanHeader>
                                {t("Due date")}
                                <div style={{ fontSize: "0.75rem", fontWeight: "bold" }}>{` [${t(getDateFormat(props.regionId))}]`}</div>
                              </StyledTableCSS.AccordianSpanHeader>
                              <StyledTableCSS.AccordianSpanBody>{invoice.formattedDueDate}</StyledTableCSS.AccordianSpanBody>
                            </StyledTableCSS.AccordianDiv>

                            {(props.viewInvoicesPermission !== "ReadOnly" && (
                              invoice.invoiceAvailable ?
                                <StyledTableCSS.AccordianDiv style={{ margin: "1.5rem 0 0 0" }}>
                                  <Wrapper>
                                    <DownlodIconStyle
                                      id="download-invoice"
                                      alt="download-icon"
                                      tabIndex="0"
                                      aria-label="Download selected invoice"
                                      src={DownloadIcon}
                                      onClick={() => handleSingleDownload(invoice.invoiceNumber, props.contractAccount)}
                                    />
                                  </Wrapper>
                                  <Wrapper>
                                    <CustomTextLink onClick={() => handleSingleDownload(invoice.invoiceNumber, props.contractAccount)}>
                                      {t("Download Invoice")}
                                    </CustomTextLink>
                                  </Wrapper>
                                </StyledTableCSS.AccordianDiv>
                                : <StyledTableCSS.AccordianDiv>
                                  <StyledTableCSS.AccordianSpanHeader>
                                    {INVOICE_HISTORY_CONSTANTS.AVAILABLE_ON}
                                    <div style={{ fontSize: "0.75rem", fontWeight: "bold" }}>{` [${t(getDateFormat(props.regionId))}]`}</div>
                                  </StyledTableCSS.AccordianSpanHeader>
                                  <StyledTableCSS.AccordianSpanBody>{invoice.invoiceAvailableDate}</StyledTableCSS.AccordianSpanBody>
                                </StyledTableCSS.AccordianDiv>))}

                          </td>
                        </StyledTableCSS.TableBodyContainer>
                      )}
                    </>
                  ))
                ) : (
                  <StyledTableCSS.TableBodyContainer style={{ display: "block" }}>
                    {" "}
                    <td style={{ all: "unset" }}>
                      <h4 style={{ textAlign: "center" }} aria-label="No Records to display">
                        {t("No Records to display")}
                      </h4>
                    </td>
                  </StyledTableCSS.TableBodyContainer>
                )}
              </tbody>
            </StyledTableCSS.TableWrapper>
          </div>
        ) : (
          props.windowSize.width < DESKTOP && renderMobileInvoiceRow()
        )}
      </>
      {props.windowSize.width >= LARGE_DESKTOP && (
        <StyledTableCSS.TableWrapper aria-label="Invoice history" ref={tableSearchRef}>
          <thead>
            <StyledTableCSS.TableHeaderContainer aria-label="Table Header">
              <MediumTextTableHeader
                className="tableHeaderStyle"
                id={getDynamicId(props.userLanguage, "invoiceDateHeaderId")}
                scope="col"
                style={{
                  width: props.windowSize.width < DESKTOP ? "18.5%" : "15.5%",
                  display: "flex",
                  flexDirection: "column",
                }}
                aria-sort={getSortStatusTxt(props.sortStatusInvoiceDate)}
              >
                <button
                  id="sort-invoice-date"
                  className="sortableCol"
                  tabIndex="0"
                  onClick={() => tableSort("invoiceDate", props.sortStatusInvoiceDate, "sortStatusInvoiceDate")}
                >
                  {t("Invoice date")}
                  {renderSortingIcons(props.sortStatusInvoiceDate)}
                </button>
              </MediumTextTableHeader>

              <MediumTextTableHeader
                className="tableHeaderStyle"
                id={getDynamicId(props.userLanguage, "invoiceNumberHeaderId")}
                aria-sort={getSortStatusTxt(props.sortStatusInvoiceNo)}
                scope="col"
                style={{
                  width: props.windowSize.width < DESKTOP ? "25%" : "16%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <button
                  className="sortableCol"
                  tabIndex="0"
                  id="invoiceNum"
                  onClick={() => tableSort("invoiceNumber", props.sortStatusInvoiceNo, "sortStatusInvoiceNo")}
                >
                  {t("Invoice number")}
                  <CustomTooltip
                    marginLeft="8px"
                    marginRight="2px"
                    renderAnchorElement={() => (
                      <StyledImage
                        width="1rem"
                        height="1rem"
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                        src={InfoIcon}
                        alt="help"
                      />
                    )}
                  >
                    {t("Click on the invoice number to view the invoice. Click on the download icon to download a copy.")}
                  </CustomTooltip>
                  {renderSortingIcons(props.sortStatusInvoiceNo)}
                </button>
              </MediumTextTableHeader>

              <MediumTextTableHeader
                style={{ width: props.windowSize.width < DESKTOP ? "17%" : "14%" }}
                scope="col"
                className="tableHeaderStyle tableHeaderRes"
                id={getDynamicId(props.userLanguage, "invoiceAmountHeaderId")}
              >
                {t("Invoice amount")}
              </MediumTextTableHeader>
              <MediumTextTableHeader
                style={{ width: props.windowSize.width < DESKTOP ? "16.5%" : "13%" }}
                scope="col"
                className="tableHeaderStyle"
                id={getDynamicId(props.userLanguage, "invoiceBalanceHeaderId")}
              >
                {t("Invoice balance")}
              </MediumTextTableHeader>

              <MediumTextTableHeader
                className="tableHeaderStyle"
                id={getDynamicId(props.userLanguage, "invoiceStatusHeaderId")}
                style={{ width: props.windowSize.width < DESKTOP ? "17%" : "14.5%" }}
                aria-sort={getSortStatusTxt(props.sortStatusPayStatus)}
                scope="col"
              >
                <button
                  id="sort-invoice-status"
                  className="sortableCol"
                  tabIndex="0"
                  onClick={() => tableSort("status", props.sortStatusPayStatus, "sortStatusPayStatus")}
                >
                  {t("Invoice status")}
                  {renderSortingIcons(props.sortStatusPayStatus)}
                </button>
              </MediumTextTableHeader>
              {props.windowSize.width >= DESKTOP && (
                <>
                  <MediumTextTableHeader
                    style={{
                      width: "12.5%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                    scope="col"
                    className="tableHeaderStyle"
                    id={getDynamicId(props.userLanguage, "dueDateHeaderId")}
                  >
                    {t("Due date")}
                  </MediumTextTableHeader>

                  <MediumTextTableHeader
                    style={{ width: "12.5%" }}
                    scope="col"
                    className="tableHeaderStyle"
                    id={getDynamicId(props.userLanguage, "downloadHeaderId")}
                  >
                    {props.viewInvoicesPermission !== "ReadOnly" ? t("Download") : ""}
                  </MediumTextTableHeader>
                </>
              )}
            </StyledTableCSS.TableHeaderContainer>
          </thead>

          <tbody>
            {props.tableData.length !== 0 ? (
              props.tableData.map((invoice, index) => (
                <>
                  {renderInvoiceRow(invoice, index)}
                  {props.windowSize.width < DESKTOP && accordianArray.includes(invoice.invoiceNumber) && renderAccordionRow(invoice)}
                </>
              ))
            ) : (
              <StyledTableCSS.TableBodyContainer style={{ display: "block" }}>
                <td style={{ all: "unset" }}>
                  <h4 style={{ textAlign: "center", fontFamily: "neue-haas-grotesk-text", fontSize: "0.75rem" }} aria-label="No Records to display">
                    {t("No Records to display")}
                  </h4>
                </td>
              </StyledTableCSS.TableBodyContainer>
            )}
          </tbody>
        </StyledTableCSS.TableWrapper>
      )}
      {props.tableData.length !== 0 && (
        <nav aria-label="pagination">
          <StyledPaginationCSS.BillingBottom className="pagination">
            <StyledPaginationCSS.RightDiv>
              <Icon
                id="invoice-pagination-left-arrow"
                name="left-arrow"
                size="small"
                color="#000000"
                style={{ fontWeight: "bold" }}
                backgroundColor="transparent"
                aria-hidden="true"
                tabIndex="-1"
              />
              <Pagination
                activePage={props.activePage}
                itemsCountPerPage={props.recordsPerPage}
                totalItemsCount={props.totalNumberOfRecords}
                pageRangeDisplayed={pageRangeDisplayed}
                onChange={handlePageChange}
                prevPageText={t("Previous")}
                nextPageText={t("Next")}
                hideFirstLastPages="true"
                itemClassPrev="firstPage"
                itemClassNext="nextPage"
              />
              <Icon
                id="invoice-pagination-right-arrow"
                name="right-arrow"
                size="small"
                color="#000000"
                style={{ fontWeight: "bold" }}
                backgroundColor="transparent"
                aria-hidden="true"
                tabIndex="-1"
              />
            </StyledPaginationCSS.RightDiv>
          </StyledPaginationCSS.BillingBottom>
        </nav>
      )}
    </>
  );
}
InvoiceHistory.propTypes = {
  setSortStatusInvoiceNo: PropTypes.func.isRequired,
  setSortStatusInvoiceDate: PropTypes.func.isRequired,
  setSortStatusContract: PropTypes.func.isRequired,
  setSortStatusLocation: PropTypes.func.isRequired,
  setSortStatusAmount: PropTypes.func.isRequired,
  setSortStatusDueAmount: PropTypes.func.isRequired,
  setSortStatusPayStatus: PropTypes.func.isRequired,
  setSortStatusDueDate: PropTypes.func.isRequired,
  setLoader: PropTypes.func.isRequired,
  setFilteredData: PropTypes.func.isRequired,
  setPageCount: PropTypes.func.isRequired,
  setTotalNumberOfRecords: PropTypes.func.isRequired,
  setTableData: PropTypes.func.isRequired,
  setActivePage: PropTypes.func.isRequired,
  setActionName: PropTypes.func.isRequired,
  setDateFrom: PropTypes.func.isRequired,
  setSearchOrRefresh: PropTypes.func.isRequired,
  setDateTo: PropTypes.func.isRequired,
  setAlertModal: PropTypes.func.isRequired,
  setShowModal: PropTypes.func.isRequired,
  accountNumber: PropTypes.string, // or PropTypes.number, depending on your state shape
  contractAccount: PropTypes.string, // or PropTypes.number
  setViewInvoiceError: PropTypes.func.isRequired,
  setDownloadInvoiceError: PropTypes.func.isRequired,
  actionName: PropTypes.string,
  invoiceList: PropTypes.array,
  recordsPerPage: PropTypes.number,
  filteredData: PropTypes.array,
  activePage: PropTypes.number,
  regionId: PropTypes.string,
  dateFrom: PropTypes.string,
  dateTo: PropTypes.string,
  pageCount: PropTypes.number,
  inputValue: PropTypes.string,
  selectedFilterBy: PropTypes.string,
  windowSize: PropTypes.object,
  viewInvoicesPermission: PropTypes.string,
  userLanguage: PropTypes.string,
  currencySymbol: PropTypes.string,
  alertModal: PropTypes.bool,
  loader: PropTypes.bool,
  showModal: PropTypes.bool,
  sortStatusInvoiceNo: PropTypes.string,
  sortStatusInvoiceDate: PropTypes.string,
  totalNumberOfRecords: PropTypes.number,
  tableData: PropTypes.array,
  searchOrRefresh: PropTypes.string,
  sortStatusPayStatus: PropTypes.string,
};
const mapDispatchToProps = {
  setInvoiceList: Actions.setInvoiceList,
  setActualInvoicelist: Actions.setActualInvoicelist,
  setTotalNumberOfRecords: Actions.setTotalNumberOfRecords,
  setActivePage: Actions.setActivePage,
  setShowModal: Actions.setShowModal,
  setAlertModal: Actions.setAlertModal,
  setRecordsPerpage: Actions.setRecordsPerpage,
  setPageCount: Actions.setPageCount,
  setSlicedData: Actions.setSlicedData,
  setFilteredData: Actions.setFilteredData,
  setTableData: Actions.setTableData,
  setActionName: Actions.setActionName,
  setFullSearchData: Actions.setFullSearchData,
  setDateFrom: Actions.setDateFrom,
  setDateTo: Actions.setDateTo,
  setSortStatusInvoiceNo: Actions.setSortStatusInvoiceNo,
  setSortStatusInvoiceDate: Actions.setSortStatusInvoiceDate,
  setSortStatusContract: Actions.setSortStatusContract,
  setSortStatusLocation: Actions.setSortStatusLocation,
  setSortStatusAmount: Actions.setSortStatusAmount,
  setSortStatusDueAmount: Actions.setSortStatusDueAmount,
  setSortStatusPayStatus: Actions.setSortStatusPayStatus,
  setSortStatusDueDate: Actions.setSortStatusDueDate,
  setSearchOrRefresh: Actions.setSearchOrRefresh,
  reset: Actions.reset,
  load: Actions.loadData,
  setLoader: Actions.setLoader,
  setViewInvoiceError: Actions.setViewInvoiceError,
  setDownloadInvoiceError: Actions.setDownloadInvoiceError,
};
const mapStateToProps = (state) => {
  return {
    accountNumber: state.ACCOUNT.accountNumber,
    viewInvoicesPermission: state.ACCOUNT.viewInvoicesPermission,
    contractAccount: state.BILLING.contractAccount,
    currencySymbol: state.BILLING.currencySymbol,
    invoiceList: state.INVOICE.invoiceList,
    actualInvoicelist: state.INVOICE.actualInvoicelist,
    totalNumberOfRecords: state.INVOICE.totalNumberOfRecords,
    activePage: state.INVOICE.activePage,
    showModal: state.INVOICE.showModal,
    alertModal: state.INVOICE.alertModal,
    recordsPerPage: state.INVOICE.recordsPerPage,
    pageCount: state.INVOICE.pageCount,
    slicedData: state.INVOICE.slicedData,
    filteredData: state.INVOICE.filteredData,
    tableData: state.INVOICE.tableData,
    actionName: state.INVOICE.actionName,
    selectedFilterBy: state.INVOICE.selectedFilterBy,
    fullSearchData: state.INVOICE.fullSearchData,
    dateFrom: state.INVOICE.dateFrom,
    dateTo: state.INVOICE.dateTo,
    sortStatusInvoiceNo: state.INVOICE.sortStatusInvoiceNo,
    sortStatusInvoiceDate: state.INVOICE.sortStatusInvoiceDate,
    sortStatusContract: state.INVOICE.sortStatusContract,
    sortStatusLocation: state.INVOICE.sortStatusLocation,
    sortStatusAmount: state.INVOICE.sortStatusAmount,
    sortStatusDueAmount: state.INVOICE.sortStatusDueAmount,
    sortStatusPayStatus: state.INVOICE.sortStatusPayStatus,
    sortStatusDueDate: state.INVOICE.sortStatusDueDate,
    searchOrRefresh: state.INVOICE.searchOrRefresh,
    visibleMakePayment: state.INVOICE.visibleMakePayment,
    visibleManagePayment: state.INVOICE.visibleManagePayment,
    visibleManagePaperlessBilling: state.INVOICE.visibleManagePaperlessBilling,
    visibleRecurringPayment: state.INVOICE.visibleRecurringPayment,
    token: state.INVOICE.token,
    sessionId: state.INVOICE.sessionId,
    vepsURL: state.INVOICE.vepsURL,
    loader: state.INVOICE.loader,
    windowSize: state.ACCOUNT.windowSize,
    regionId: state.ACCOUNT.regionId,
    userLanguage: state.ACCOUNT.userLanguage,
    downloadInvoiceError: state.INVOICE.downloadInvoiceError,
    viewInvoiceError: state.INVOICE.viewInvoiceError,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(InvoiceHistory);
